import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; 
import PageContent from 'layouts/PageContent.jsx';
import MiscellaneousQueriesFilters from './MiscellaneousQueriesFilters';
import MiscellaneousQueries from './MiscellaneousQueries';

const MiscellaneousQueriesScreen = (props) => {
    const {t, i18n} = useTranslation(['miscellaneousQueries', 'common']);
    const [filters, setFilters] = useState({})

  return (
    <>
      <PageContent title={t('miscellaneousQueries:Title')}>
        <MiscellaneousQueriesFilters setFilters={setFilters} />
        <div className='mt-2'>
          <MiscellaneousQueries filters={filters} />
        </div>
      </PageContent>
    </>
  )
}

export default MiscellaneousQueriesScreen;